export const EMPTY_FIELD_ERROR = "Field must not be empty";
export const NUMBER_ERROR = "Field value must be a number";

export const getMinLengthError = (minLengthError, minLength) =>
	minLengthError ?? `Field length must be larger or equal to ${minLength}`;

export const getMaxLengthError = (maxLengthError, maxLength) =>
	maxLengthError ?? `Field length must be smaller or equal to ${maxLength}`;

export const getMinItemsError = (minItemsErrorMessage, minItems) =>
	minItemsErrorMessage ?? `You need to add a minimum of ${minItems} items`;

export const getMaxItemsError = (maxItemsErrorMessage, maxItems) =>
	maxItemsErrorMessage ?? `The number of items that can be added is ${maxItems}`;

export const getFractionError = (fractionSize) =>
	`Field value must not contain more than ${fractionSize} decimals`;

export const getMinNumberError = (extraSettings) =>
	extraSettings.minItemsErrorMessage ??
	extraSettings.minValueErrorMessage ??
	`Field must be a number greater than or equal to ${extraSettings.min}`;

export const getMaxNumberError = (extraSettings) =>
	extraSettings.maxItemsErrorMessage ??
	extraSettings.maxValueErrorMessage ??
	`Field must be a number smaller than or equal to ${extraSettings.max}`;